import React from 'react';
import PropTypes from 'prop-types';

const Delete = ({ onClick }) => (
  <div onClick={onClick} style={{ cursor: 'pointer', margin: '0px 4px' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FF5D55"
        fillRule="nonzero"
        d="M19 9v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V9h14zM8 12a1 1 0 0 0-.993.883L7 13v5a1 1 0 0 0 1.993.117L9 18v-5a1 1 0 0 0-1-1zm8 0a1 1 0 0 0-.993.883L15 13v5a1 1 0 0 0 1.993.117L17 18v-5a1 1 0 0 0-1-1zm-4 0a1 1 0 0 0-.993.883L11 13v5a1 1 0 0 0 1.993.117L13 18v-5a1 1 0 0 0-1-1zm.57-10a2.5 2.5 0 0 1 2.358 1.667l.118.333H18a2 2 0 1 1 0 4H6a2 2 0 1 1 0-4h2.953l.119-.333A2.5 2.5 0 0 1 11.429 2h1.142zm0 1h-1.14a1.5 1.5 0 0 0-1.415 1h3.97a1.5 1.5 0 0 0-1.414-1z"
      />
    </svg>
  </div>
);

Delete.propTypes = {
  onClick: PropTypes.func,
};

export default Delete;
